import {
    CoreFetch,
    GetClaimSubmittedReportRequest,
    GetExpectedRateReportRequest,
    GetGrossCollectionsReportRequest,
    GetPatientCollectionsReportRequest,
    GetPayerMixReportRequest,
    GetPracticeSummaryReportRequest,
    ProviderReportItem,
    ReportApi,
} from '@enter/core';
import { fetch } from './util';

export class MetricsService {
    /* ==================== Metrics ==================== */

    public fetchClaimsSubmittedReport = async (
        request: GetClaimSubmittedReportRequest,
    ): Promise<ProviderReportItem[] | undefined> => {
        return fetch(request, async req => CoreFetch<ReportApi>(ReportApi).getClaimSubmittedReport(req));
    };

    public fetchPayerExpectedReport = async (
        request: GetExpectedRateReportRequest,
    ): Promise<ProviderReportItem[] | undefined> => {
        return fetch(request, async req => CoreFetch<ReportApi>(ReportApi).getExpectedRateReport(req));
    };

    public fetchGrossCollectionReport = async (
        request: GetGrossCollectionsReportRequest,
    ): Promise<ProviderReportItem[] | undefined> => {
        return fetch(request, async req => CoreFetch<ReportApi>(ReportApi).getGrossCollectionsReport(req));
    };

    public fetchPatientCollectionsReport = async (
        request: GetPatientCollectionsReportRequest,
    ): Promise<ProviderReportItem[] | undefined> => {
        return fetch(request, async req => {
            return CoreFetch<ReportApi>(ReportApi).getPatientCollectionsReport(req);
        });
    };

    public fetchPracticeSummaryReport = async (
        request: GetPracticeSummaryReportRequest,
    ): Promise<ProviderReportItem[] | undefined> => {
        return fetch(request, async req => {
            return CoreFetch<ReportApi>(ReportApi).getPracticeSummaryReport(req);
        });
    };

    public fetchPayerMixReport = async (
        request: GetPayerMixReportRequest,
    ): Promise<ProviderReportItem[] | undefined> => {
        return fetch(request, async req => {
            return CoreFetch<ReportApi>(ReportApi).getPayerMixReport(req);
        });
    };
}
